import { useEffect } from "react";

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} - Roots`;
  }, [title]);
};

export default useTitle;
